const state = {
    get refreshState() {
        return localStorage.getItem('refreshState');
    },
    set refreshState(vaule) {
        return localStorage.setItem('refreshState', vaule);
    },
};

export default state;